import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { startCase } from 'lodash';
import './ReSign.scss';

const getContactUsLink = (props) => {
  let contactUri = '/contact-us/My account/Billing and payment/';
  if (props.email && props.name) {
    contactUri = `${contactUri}?email=${props.email}&name=${startCase(props.name)}`;
  }
  return encodeURI(contactUri);
};

const ReSignContact = props => (
  <div>
    <ul>
      <li>
        <div className="gina-logo" />
        <div>Chat with us: Ask Gina by clicking “Got a question?” below.</div>
      </li>
      <li>
        <Link
          to={getContactUsLink(props)}
          target="_blank"
          onlyActiveOnIndex={false}
        >
          <div className="contact-logo" />
          <div>
            Using our Contact us form.
          </div>
        </Link>
      </li>
    </ul>
  </div>
);

ReSignContact.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string
};

export default ReSignContact;



/** WEBPACK FOOTER **
 ** ./src/components/ReSign/ReSignContact.js
 **/